export const MOCK_TRANSFER_WAREHOUSES = [
  { id: "wh-1", name: "Warehouse Bangalore" },
  { id: "wh-2", name: "Peelamedu Depot" },
  { id: "wh-3", name: "Warehouse Mysore" },
  { id: "wh-4", name: "Warehouse Chennai" },
  { id: "wh-5", name: "Coimbatore Central Warehouse" },
];

export const MOCK_TRANSFER_PRODUCTS = [
  {
    id: "prod-101",
    name: "MCB 32A C-Curve 3-Pole",
    manufacturer: "Schneider Electric",
    partNumber: "LS-MCB-32C3",
    uom: "Nos",
  },
  {
    id: "prod-102",
    name: "Submersible Pump Type A",
    manufacturer: "Kirloskar Brothers",
    partNumber: "WP-SUB-A01",
    uom: "Nos",
  },
  {
    id: "prod-103",
    name: "Gate Valve DN100 PN16",
    manufacturer: "L&T Valves",
    partNumber: "FL-GVAL-100",
    uom: "Nos",
  },
  {
    id: "prod-104",
    name: "LED Panel Light 15W 6500K",
    manufacturer: "Philips Lighting",
    partNumber: "LT-PAN-15W",
    uom: "Nos",
  },
];

export const MOCK_TRANSFER_BATCHES = [
  // MCB 32A C-Curve 3-Pole (prod-101)
  {
    batchNumber: "B-MCB-101",
    warehouseId: "wh-1", // Bangalore
    productId: "prod-101",
    availableQty: 150,
    receiptDate: "2025-01-10",
  },
  {
    batchNumber: "B-MCB-102",
    warehouseId: "wh-1", // Bangalore
    productId: "prod-101",
    availableQty: 80,
    receiptDate: "2025-02-15",
  },
  {
    batchNumber: "B-MCB-201",
    warehouseId: "wh-2", // Peelamedu
    productId: "prod-101",
    availableQty: 60,
    receiptDate: "2025-03-05",
  },
  {
    batchNumber: "B-MCB-999", // Zero quantity batch (should not appear in Batch selector)
    warehouseId: "wh-1", // Bangalore
    productId: "prod-101",
    availableQty: 0,
    receiptDate: "2025-04-20",
  },

  // Submersible Pump Type A (prod-102)
  {
    batchNumber: "B-PMP-101",
    warehouseId: "wh-1", // Bangalore
    productId: "prod-102",
    availableQty: 45,
    receiptDate: "2024-11-20",
  },
  {
    batchNumber: "B-PMP-301",
    warehouseId: "wh-3", // Mysore
    productId: "prod-102",
    availableQty: 30,
    receiptDate: "2025-03-01",
  },
  {
    batchNumber: "B-PMP-999", // Zero quantity
    warehouseId: "wh-1",
    productId: "prod-102",
    availableQty: 0,
    receiptDate: "2025-02-10",
  },

  // Gate Valve DN100 PN16 (prod-103)
  {
    batchNumber: "B-VAL-201",
    warehouseId: "wh-2", // Peelamedu
    productId: "prod-103",
    availableQty: 25,
    receiptDate: "2025-05-18",
  },
  {
    batchNumber: "B-VAL-501",
    warehouseId: "wh-5", // Coimbatore
    productId: "prod-103",
    availableQty: 10,
    receiptDate: "2025-06-10",
  },

  // LED Panel Light 15W 6500K (prod-104)
  {
    batchNumber: "B-LED-301",
    warehouseId: "wh-3", // Mysore
    productId: "prod-104",
    availableQty: 300,
    receiptDate: "2025-02-14",
  },
  {
    batchNumber: "B-LED-401",
    warehouseId: "wh-4", // Chennai
    productId: "prod-104",
    availableQty: 120,
    receiptDate: "2025-01-20",
  },
];
